import { useEffect } from "react";
import { Typography } from "@mui/material";
import Button from "@mui/material/Button";
import { useTranslate } from "../../../hooks/useTranslate";
import { isVersionUK } from "../../../services/versionService";
import { EMAIL_UK, EMAIL_US } from "../../../constants/add-student-email";

const email = isVersionUK ? EMAIL_UK : EMAIL_US;

export const Complete = (props) => {
    const {
        homeLink,
        clearStoredData,
    } = props;
    const { t } = useTranslate();

    useEffect(() => () => {
        clearStoredData();
    }, [clearStoredData]);

    return (
        <div className="complete-narrow">
            <Typography variant="h1">
                {t("addStudent.complete.title")}
            </Typography>
            <Typography variant="h5" component="div" className="mt-4">
                {t("addStudent.complete.description")}
            </Typography>
            {isVersionUK && (
                <Typography variant="h5" component="div" className="mt-4">
                    {t("addStudent.complete.lookForward")}
                </Typography>
            )}
            <Button
                href={homeLink}
                variant="contained"
                className="button-accent mt-4"
            >
                {t("addStudent.complete.returnHome")}
            </Button>
        </div>
    );
};
